import React, { useEffect, useRef } from "react";

import "../../images/css/networkStatus.css";

interface NetworkStatusProps {
  setIsOnline: (status: boolean) => void;
}

const NetworkStatus: React.FC<NetworkStatusProps> = ({ setIsOnline }) => {
  const hasReloaded = useRef(false);

  useEffect(() => {
    document.title = "AskWellie | Network Error";
    const updateNetworkStatus = () => {
      const online = navigator.onLine;
      setIsOnline(online);
      if (online && !hasReloaded.current) {
        hasReloaded.current = true;
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    };

    window.addEventListener("online", updateNetworkStatus);
    window.addEventListener("offline", updateNetworkStatus);

    return () => {
      window.removeEventListener("online", updateNetworkStatus);
      window.removeEventListener("offline", updateNetworkStatus);
    };
  }, [setIsOnline]);

  return null;
};

export default NetworkStatus;
